import React from 'react';
import * as SliderPrimitive from '@radix-ui/react-slider';
import { cn } from '@/lib/utils';

/**
 * Multi-thumb range slider built on the same Radix primitive the app's
 * shadcn `Slider` already uses — reused rather than hand-rolling a custom
 * drag engine. The shadcn wrapper only renders one Thumb; this renders one
 * Thumb per value, which is what trim in/out handles need.
 */
export const RangeSlider = React.forwardRef(({ className, value, ...props }, ref) => (
  <SliderPrimitive.Root
    ref={ref}
    value={value}
    className={cn('relative flex w-full touch-none select-none items-center', className)}
    {...props}
  >
    <SliderPrimitive.Track className="relative h-1.5 w-full grow overflow-hidden rounded-full bg-white/10">
      <SliderPrimitive.Range className="absolute h-full bg-[#3A7BFF]" />
    </SliderPrimitive.Track>
    {value.map((_, i) => (
      <SliderPrimitive.Thumb
        key={i}
        data-testid={`range-slider-thumb-${i}`}
        className="block h-4 w-4 rounded-full border-2 border-[#3A7BFF] bg-white shadow transition-transform hover:scale-110 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#3A7BFF] disabled:pointer-events-none disabled:opacity-50"
      />
    ))}
  </SliderPrimitive.Root>
));
RangeSlider.displayName = 'RangeSlider';
